interface DiagonalShimmerProps {
  className?: string;
  colors?: string[];
  duration?: number;
  backgroundSize?: string;
  position?: "absolute" | "relative" | "fixed";
  gradient?: string; // new prop for custom gradient
}

const DiagonalShimmer = ({
  className,
  colors = ["#FEF4F1", "#FDEFF5", "#EDF8FC", "#EDFCF8"],
  duration = 15,
  backgroundSize = "400% 200%",
  position = "absolute",
  gradient, // new prop
}: DiagonalShimmerProps) => {
  const gradientColors = colors.join(", ");

  return (
    <div
      role="status"
      className={`${position} inset-0 flex items-center justify-center h-full w-full ${className || ""}`}
    >
      <div
        className="h-full w-full flex items-center justify-center"
        style={{
          background: gradient ? gradient : `linear-gradient(-45deg, ${gradientColors})`,
          backgroundSize,
          animation: `gradient ${duration}s ease infinite`,
        }}
      />
      <style>{`
        @keyframes gradient {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }
      `}</style>
    </div>
  );
};

export default DiagonalShimmer;
